import { render, staticRenderFns } from "./sizhen-add.vue?vue&type=template&id=a488a0fc&scoped=true"
import script from "./sizhen-add.vue?vue&type=script&lang=ts"
export * from "./sizhen-add.vue?vue&type=script&lang=ts"
import style0 from "./sizhen-add.vue?vue&type=style&index=0&id=a488a0fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a488a0fc",
  null
  
)

export default component.exports